module.exports = __webpack_public_path__ + "img/run-for-good.dbbd2b1b.png";